import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { take, withLatestFrom } from 'rxjs/operators';
import { PharmacyManagementSystemIntegrationStepsEnum } from 'src/app/settings/interfaces/PharmacyManagementSystemIntegrationStepsEnum';
import { AlertTypesEnum } from 'src/app/shared/interfaces/AlertTypesEnum';
import { PinService } from 'src/app/shared/services/pin.service';
import { InitiateFrameworkLtcIntegration } from 'src/app/shared/states/settings/settings.actions';
import { SettingsState } from 'src/app/shared/states/settings/settings.state';

@UntilDestroy()
@Component({
  selector: 'app-framework-ltc-setup',
  templateUrl: './framework-ltc.component.html',
  styleUrls: ['.././pms-integration-stepper-shared.component.scss', './framework-ltc.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FrameworkLtcSetupComponent implements OnInit {
  @Input() progress: PharmacyManagementSystemIntegrationStepsEnum;

  @Output() back: EventEmitter<PharmacyManagementSystemIntegrationStepsEnum> = new EventEmitter();
  @Output() next: EventEmitter<PharmacyManagementSystemIntegrationStepsEnum> = new EventEmitter();
  @Output() ok: EventEmitter<any> = new EventEmitter();

  PharmacyManagementSystemIntegrationStepsEnum = PharmacyManagementSystemIntegrationStepsEnum;
  
  @Select(SettingsState.loading) loading$: Observable<boolean | undefined>;
  @Select(SettingsState.success) success$: Observable<boolean | undefined>;

  private pinDialogChannel = "pin";
  AlertTypesEnum = AlertTypesEnum;
  /**
   *
   */
  constructor(
    private store: Store,
    private pinService: PinService
  ) {
    
  }

  ngOnInit(): void {
    this.pinService.validatePin$
    .pipe(untilDestroyed(this))
    .subscribe(res => {
      if (res?.dialogId === this.pinDialogChannel && res?.success) {
       this.store.dispatch(new InitiateFrameworkLtcIntegration(res.pin))
       .pipe(take(1), withLatestFrom(this.success$))
       .subscribe(([_, success]) => {
        if (success) {
          this.next.emit(PharmacyManagementSystemIntegrationStepsEnum.Finish);
        }
       })
      }
    })
  }

  showPin(): void {
    this.pinService.setDialogId(this.pinDialogChannel);
    this.pinService.showPinDialog$.next(true);
  }
}
